//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Motion.js";
import "../no/Builder.js";
let d=[[],[[["graphOption"],"SetExportGraphOption",{},1,0],[[],"GetExportGraphOption",{R_:{graphOption:''}},0,0],[["format"],"SetExportGraphFormat",{},1,0],[[],"GetExportGraphFormat",{R_:{format:''}},0,0],[["removeResults"],"SetRemoveResultsAfterExportingGraphs",{},1,0],[[],"GetRemoveResultsAfterExportingGraphs",{R_:{removeResults:''}},0,0],[["removeResults"],"SetMaxConcurrentSimulationCount",{},1,0],[[],"GetMaxConcurrentSimulationCount",{R_:{removeResults:''}},0,0],[["url","username","password","keepPassword"],"SetRemoteCredentials",{},4,0],[["selectedRunnerId"],"SetRunners",{},1,0]],[]];
SPLM.Motion.SolutionManagerSettingsBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Motion.SolutionManagerSettingsBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Motion.SolutionManagerSettingsBuilder.ExportGraphFormat = Object.freeze({
    "Csv" : "Csv", "Rpciii" : "Rpciii", "Afu" : "Afu", "Dac" : "Dac"});

SPLM.Motion.SolutionManagerSettingsBuilder.ExportGraphOption = Object.freeze({
    "None" : "None", "SingleFile" : "SingleFile", "MultipleFiles" : "MultipleFiles"});

export default SPLM;